import * as React from "react";
import { marked, type Tokens } from "marked";
import xss from "xss";
import style = require("./style.less");

marked.use({
    gfm: true,
    renderer: {
        link({ href, title, text }: Tokens.Link) {
            const titleAttr = title ? ` title="${title}"` : "";
            return `<a href="${href}"${titleAttr} target="_blank" rel="noopener noreferrer">${text}</a>`;
        }
    }
});

interface MarkdownProps {
    markup: string;
}

const Markdown: React.FC<MarkdownProps> = ({ markup }) => {
    const html = xss(marked.parse(markup) as string);
    return <div className={style.markdown} dangerouslySetInnerHTML={{ __html: html }} />;
};

export default Markdown;
